import { apiClient } from '../../../utils/axios';
import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const fetchWebhookStatus = async (query) => {
  const { data } = await apiClient.get(`/shopify/stores/${query.queryKey[1]}/webhook-status`, {
    headers: {
      Authorization: `Bearer ${query.queryKey[2]}`,
    },
  });
  return data;
};

export const useGetWebhookStatusHandler = (store, token) => {
  const dispatch = useDispatch();

  const {
    data: webhookRegistered,
    isLoading,
    isFetching,
    error,
    isError,
  } = useQuery({
    queryKey: ['webhook-status', store, token],
    queryFn: fetchWebhookStatus,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return { webhookRegistered, isLoading, isFetching, error };
};
